import { STATES } from './constants';

export const styleByState = (mappings) => (props) => {
  if (props[STATES.DISABLED]) {
    return invokeIfFunc(mappings[STATES.DISABLED], props);
  }
  if (props[STATES.ERROR]) {
    return invokeIfFunc(mappings[STATES.ERROR], props);
  }
  if (props[STATES.COMPLETED]) {
    return invokeIfFunc(mappings[STATES.COMPLETED], props);
  }
  if (props[STATES.ACTIVE]) {
    return invokeIfFunc(mappings[STATES.ACTIVE], props);
  }
  if (props[STATES.INCOMPLETE]) {
    return invokeIfFunc(mappings[STATES.INCOMPLETE], props);
  }
};

const invokeIfFunc = (funcOrObj, props) => (typeof funcOrObj === 'function' ? funcOrObj(props) : funcOrObj);
